import { i18next } from '@frontend/i18n';

const numberWords = [
  i18next.t('zero', { ns: 'schedule' }),
  i18next.t('one', { ns: 'schedule' }),
  i18next.t('two', { ns: 'schedule' }),
  i18next.t('three', { ns: 'schedule' }),
  i18next.t('four', { ns: 'schedule' }),
];

export const getHelperText = (count: number) => {
  if (count === 0) return i18next.t('Select at least one location', { ns: 'schedule' });
  if (count === 1) return i18next.t('View one location', { ns: 'schedule' });
  if (count <= 4) return i18next.t('View {{word}} locations', { ns: 'schedule', word: numberWords[count] });
  return i18next.t('View {{count}} locations', { ns: 'schedule', count });
};
